import { render, staticRenderFns } from "./TongZhiGongGao.vue?vue&type=template&id=104192dc&scoped=true&"
import script from "./TongZhiGongGao.vue?vue&type=script&lang=js&"
export * from "./TongZhiGongGao.vue?vue&type=script&lang=js&"
import style0 from "./TongZhiGongGao.vue?vue&type=style&index=0&id=104192dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104192dc",
  null
  
)

export default component.exports